import {
  Badge,
  Box,
  Button,
  Checkbox,
  ComboboxItem,
  Divider,
  Fieldset,
  Flex,
  Grid,
  Group,
  MultiSelect,
  ScrollArea,
  Select,
  Table,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { hasLength, useForm } from "@mantine/form";
import { useDebouncedValue, useDisclosure } from "@mantine/hooks";
import cx from "clsx";
import { useEffect, useMemo, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { MessageResponse } from "../../../model/MessageResponse";
import { DeliveryAssignmentV2 } from "../../../model/TblDeliveryAssignment";
import classes from "../../../Styles/TableScrollArea.module.css";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { sky_blue } from "../../../const/variables";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

interface EmployeeSelect {
  value: string;
  label: string;
  phoneNumber: string;
  attribute4: string | null;
}

const DeliveryAssignmentAddressNew = ({
  dataDeliverySelect,
  onClose,
  department,
  typeDelivery,
}: {
  dataDeliverySelect: any[];
  onClose: any;
  department: string | null;
  typeDelivery: string;
}) => {
  console.log(dataDeliverySelect);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [scrolled, setScrolled] = useState(false);

  const [dataAddress, setDataAddress] = useState<any[]>([]);

  const BPGV = [
    { value: "NV điều vận", label: "NV điều vận" },
    { value: "Kỹ thuật", label: "Kỹ thuật" },
    { value: "Dự án", label: "Dự án" },
    { value: "Kỹ thuật thi công", label: "Kỹ thuật thi công" },
  ];
  const [dataEmployee1Select, setDataEmployee1Select] = useState<
    EmployeeSelect[]
  >([]);
  const [dataEmployee2Select, setDataEmployee2Select] = useState<
    EmployeeSelect[]
  >([]);
  const [dataWorkSelect, setDataWorkSelect] = useState<ComboboxItem[]>([]);

  // Search cho nhân viên giao hàng
  const [searchEmp1, setSearchEmp1] = useState<string>("");
  const [debounceSearchEmp1] = useDebouncedValue<string>(searchEmp1, 300);

  // Search cho nhân viên hỗ trợ
  const [searchEmp2, setSearchEmp2] = useState<string>("");
  const [debounceSearchEmp2] = useDebouncedValue<string>(searchEmp2, 300);

  // Danh sách gộp dùng cho phần lái xe & tra cứu tên/SĐT
  const dataEmployeedSelect = useMemo(() => {
    const map = new Map<string, EmployeeSelect>();
    [...dataEmployee1Select, ...dataEmployee2Select].forEach((item) => {
      map.set(item.value, item);
    });
    return Array.from(map.values());
  }, [dataEmployee1Select, dataEmployee2Select]);

  const form = useForm<DeliveryAssignmentV2>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      id: 0,
      assignmentDate: new Date(
        new Date().getTime() + 7 * 3600 * 1000,
      ).toISOString(),
      typeAssignment: typeDelivery,
      attribute8: department === "2" ? "223" : "",
      deliveryDepartment:
        typeDelivery === "NOI_CHUYEN"
          ? dataDeliverySelect[0]?.attribute15?.toString()
          : null,
      vehicleCode: typeDelivery === "DONG_GOI" ? null : "XE_MAY",
      isDeliveryOnSite: false,
      fromExpectedDate: dataDeliverySelect[0]?.fromDeliveryDate,
      toExpectedDate: dataDeliverySelect[0]?.deliveryAppointmentTime,

      deliveries: [],
    },

    transformValues: (values) => ({
      ...values,
      employee1: Number(values.employee1),
      employee2: Number(values.employee2),
      attribute8:
        department !== "1"
          ? String(values.attribute8)
              .split(",")
              .map((i) => i.trim())
              .join(", ")
          : String(values.attribute8),
    }),

    validate: {
      driverId: (value: number | null | undefined) => {
        if (!value && typeDelivery !== "DONG_GOI") {
          return "Vui lòng chọn người lái xe !";
        }
      },
      driverMobileNumber: (value: string | null | undefined) => {
        if (value && typeDelivery !== "DONG_GOI") {
          return hasLength(
            { max: 10, min: 10 },
            "Số điện thoại phải đủ 10 ký tự !",
          )(value as string);
        }
      },
      employee1: (value: number | null | undefined) => {
        if (!value) {
          return "Vui lòng nhập tên nhân viên giao hàng !";
        }
      },
    },
  });

  const customHeightTable = () => {
    if (dataDeliverySelect.length === 1) {
      return 110;
    } else if (dataDeliverySelect.length === 2) {
      return 150;
    } else if (dataDeliverySelect.length === 3) {
      return 190;
    } else {
      return 230;
    }
  };

  const getCreateDeliveryAssignment = async () => {
    const dataApi = await repositoryDelivery.get<
      MessageResponse<DeliveryAssignmentV2>
    >("/api/v1/TblDeliveryAssignment/create?prefix=VD-");
    if (dataApi !== null) {
      const data = dataApi?.data;
      if (data) {
        form.setValues((prev) => ({ ...prev, code: data.code }));
      }
    }
  };

  const fetchEmployeeSelect = async (
    keySearch: string,
    setData: (data: EmployeeSelect[]) => void,
  ) => {
    let url = `/api/v1/TblDmEmployee/get-list?Take=200&depType=${department}`;

    if (keySearch && keySearch.trim().length > 0) {
      url += `&KeySearch=${keySearch.trim()}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res?.success) {
      setData(
        res.data
          .filter((item: any) => item.fullname != null && item.id != null)
          .map((item: any) => ({
            value: item.id?.toString(),
            label: `${item.fullname} - ${item.code}`,
            phoneNumber: item.phoneNumber,
            attribute4: item.attribute4,
          })),
      );
    }
  };

  const dataDeliveryWorkSelect = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblDmDeliveryWork/get-all",
    );

    if (res && res.success) {
      const result = res.data;

      if (typeDelivery === "DONG_GOI") {
        form.setValues((prev) => ({
          ...prev,
          attribute8:
            String(
              result.find((i: any) => i.name.toLowerCase() === "đóng gói")?.id,
            ) || null,
        }));
      }

      setDataWorkSelect(
        result
          .filter(
            (item: any) =>
              item.name &&
              item.id &&
              item.active &&
              item.department &&
              item.department?.includes(String(department)),
          )
          .map((item: any) => ({
            value: String(item.id),
            label: String(item.name),
          })),
      );
    }
  };

  const handleCalculateDistance = async () => {
    const dataAddressCalculate = dataDeliverySelect
      ?.filter(
        (i) =>
          i.id &&
          i.fromAddress &&
          i.toAddress &&
          String(i.fromAddress).length > 0 &&
          String(i.toAddress).length > 0,
      )
      ?.map((i) => ({
        id: i.id,
        fromAddress: i.fromAddress,
        toAddress: i.toAddress,
      }));

    const res = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/VietMap/calculate-distance-one-to-one",
      {
        sourceAddresses: dataAddressCalculate.map((i) => i.fromAddress),
        destinationAddresses: dataAddressCalculate.map((i) => i.toAddress),
      },
    );

    if (res && res.success) {
      const result = res.data?.routes;
      const filterDataAPI = dataDeliverySelect.map((item) => {
        const matchingItem = result.find(
          (i: any) =>
            i.sourceAddress === item.fromAddress &&
            i.destinationAddress === item.toAddress,
        );

        if (matchingItem && item.attribute25 !== "NX") {
          return {
            ...item,
            distanceKm: matchingItem.distanceKm,
            durationMinutes: matchingItem.durationMinutes,
            durationSeconds: matchingItem.durationSeconds,
            distanceMeters: matchingItem.distanceMeters,
          };
        } else if (item.attribute25 === "NX") {
          return {
            ...item,
            distanceKm: Number(item.attribute26),
            durationMinutes: Number(item.attribute26) * 2,
            durationSeconds: Number(item.attribute26) * 120,
            distanceMeters: Number(item.attribute26) * 1000,
          };
        }

        return item;
      });

      setDataAddress(filterDataAPI);
      form.setValues((prev) => ({
        ...prev,
        distance:
          typeDelivery === "GHEP_DON" || typeDelivery === "DONG_GOI"
            ? 0
            : filterDataAPI.reduce((sum, i) => {
                return sum + i.distanceMeters;
              }, 0),
        distanceTotal:
          typeDelivery === "GHEP_DON" || typeDelivery === "DONG_GOI"
            ? 0
            : filterDataAPI.reduce((sum, i) => {
                return sum + i.distanceMeters;
              }, 0),
        estimatedTime:
          typeDelivery === "GHEP_DON" || typeDelivery === "DONG_GOI"
            ? 0
            : filterDataAPI.reduce((sum, i) => {
                return sum + i.durationSeconds;
              }, 0),
        deliveries: filterDataAPI.map((i) => ({
          deliveryId: Number(i.id),
          durationEstimated:
            typeDelivery === "DONG_GOI" ? 0 : i.durationSeconds,
          distanceEstimated: typeDelivery === "DONG_GOI" ? 0 : i.distanceMeters,
          isPayroll: false,
        })),
      }));
    } else {
      setDataAddress([]);
    }
  };

  const handleCreateTblDeliveryAssignment = async (
    dataSubmit: DeliveryAssignmentV2,
  ) => {
    const updatedDataSubmit = {
      ...dataSubmit,
      deliveries: dataSubmit.deliveries,
    };

    open();
    const dataApi = await repositoryDelivery.post<
      MessageResponse<DeliveryAssignmentV2>
    >("/api/v1/TblDeliveryAssignment/create-v2", updatedDataSubmit);
    if (dataApi?.success) {
      NotificationExtension.Success("Phân đơn giao hàng thành công !");
      setTimeout(() => {
        onClose((prev: any) => !prev);
        modals.closeAll();
      }, 300);
    }
    close();
  };

  useEffect(() => {
    Promise.all([dataDeliveryWorkSelect(), getCreateDeliveryAssignment()]);
  }, []);

  useEffect(() => {
    fetchEmployeeSelect(debounceSearchEmp1, setDataEmployee1Select);
  }, [debounceSearchEmp1]);

  useEffect(() => {
    fetchEmployeeSelect(debounceSearchEmp2, setDataEmployee2Select);
  }, [debounceSearchEmp2]);

  useEffect(() => {
    if (dataDeliverySelect.length > 0) {
      handleCalculateDistance();
    } else {
      setDataAddress([]);
    }
  }, [dataDeliverySelect]);

  useEffect(() => {
    if (typeDelivery !== "DONG_GOI") {
      const vehicleC = getValueById(
        form.getValues()?.driverId?.toString() ?? "",
        dataEmployeedSelect,
        "attribute4",
      );

      if (form.getValues()?.driverId && form.getValues()?.driverId !== 0) {
        form.setValues((prev) => ({
          ...prev,
          vehicleCode: vehicleC && vehicleC !== "null" ? vehicleC : "XE_MAY",
          payroll1: vehicleC === "O_TO" ? false : form.getValues()?.payroll1,
          payroll2: vehicleC === "O_TO" ? false : form.getValues()?.payroll2,
        }));
      }
    }
  }, [form.getValues()?.driverId, typeDelivery]);

  return (
    <Box
      component="form"
      m={"5px 0px"}
      onSubmit={form.onSubmit((e: DeliveryAssignmentV2) => {
        handleCreateTblDeliveryAssignment(e);
      })}
      style={{ position: "relative" }}
    >
      <Grid>
        <Grid.Col
          span={{ base: 12, md: 12, lg: typeDelivery === "DONG_GOI" ? 12 : 6 }}
        >
          <Fieldset legend="Thông tin giao nhận" p={"0px 15px 7.5px 15px"}>
            <Grid>
              <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
                <TextInput
                  key={form.key("code")}
                  label="Mã phân công giao vận"
                  placeholder="Nhập mã phân công giao vận"
                  variant="filled"
                  readOnly
                  {...form.getInputProps("code")}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
                <DateTimePicker
                  label="Ngày phân công"
                  placeholder="Nhập ngày phân công"
                  value={new Date()}
                  valueFormat="DD/MM/YYYY HH:mm A"
                  variant="filled"
                  readOnly
                />
              </Grid.Col>
            </Grid>
            <Grid>
              {typeDelivery !== "DONG_GOI" && (
                <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
                  <Select
                    label="Phương tiện giao hàng"
                    placeholder="Chọn phương tiện giao hàng"
                    clearable
                    data={[
                      { label: "Xe máy", value: "XE_MAY" },
                      { label: "Ô tô", value: "O_TO" },
                    ]}
                    value={
                      form.getValues().vehicleCode
                        ? form.getValues().vehicleCode?.toString()
                        : null
                    }
                    {...form.getInputProps("vehicleCode")}
                    onChange={(e) =>
                      form.setValues((prev) => ({
                        ...prev,
                        vehicleCode: e ? e : "XE_MAY",
                        payroll1:
                          e === "O_TO" ? false : form.getValues()?.payroll1,
                        payroll2:
                          e === "O_TO" ? false : form.getValues()?.payroll2,
                      }))
                    }
                  />
                </Grid.Col>
              )}
              <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
                <MultiSelect
                  label="Công việc"
                  placeholder="Chọn loại công việc"
                  clearable
                  data={dataWorkSelect}
                  value={
                    form.getValues()?.attribute8 &&
                    String(form.getValues()?.attribute8).length > 0
                      ? String(form.getValues()?.attribute8).split(",")
                      : []
                  }
                  {...form.getInputProps("attribute8")}
                  onChange={(e) =>
                    form.setValues((prev) => ({
                      ...prev,
                      attribute8: e ? e.join(",") : "",
                    }))
                  }
                  disabled={typeDelivery === "DONG_GOI"}
                  nothingFoundMessage="Không có dữ liệu !"
                />
              </Grid.Col>
              {typeDelivery === "DONG_GOI" && (
                <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
                  <TextInput
                    key={form.key("description")}
                    label="Ghi chú"
                    placeholder="Ghi chú"
                    {...form.getInputProps("description")}
                  />
                </Grid.Col>
              )}
            </Grid>
            {typeDelivery !== "DONG_GOI" && (
              <Grid>
                <Grid.Col span={12}>
                  <TextInput
                    key={form.key("description")}
                    label="Ghi chú"
                    placeholder="Ghi chú"
                    {...form.getInputProps("description")}
                  />
                </Grid.Col>
              </Grid>
            )}
          </Fieldset>
        </Grid.Col>
        <Grid.Col
          span={{ base: 12, md: 12, lg: typeDelivery === "DONG_GOI" ? 12 : 6 }}
        >
          <Fieldset legend="Nhân viên phân công" p={"0px 15px 7.5px 15px"}>
            <Grid>
              <Grid.Col
                span={{
                  base: 12,
                  md: 6,
                  lg: typeDelivery === "DONG_GOI" ? 10 : 7.5,
                }}
              >
                <Select
                  label={
                    typeDelivery === "DONG_GOI"
                      ? "Nhân viên đóng gói"
                      : "Nhân viên giao hàng"
                  }
                  placeholder={
                    typeDelivery === "DONG_GOI"
                      ? "Nhập tên nhân viên đóng gói"
                      : "Nhập tên nhân viên giao hàng"
                  }
                  data={dataEmployee1Select
                    ?.filter(
                      (item: any) =>
                        item.value !== form.getValues().employee2?.toString(),
                    )
                    ?.map((item: any) => ({
                      value: item.value,
                      label: item.label,
                    }))}
                  value={
                    form.getValues().employee1
                      ? form.getValues().employee1?.toString()
                      : null
                  }
                  {...form.getInputProps("employee1")}
                  onChange={(e) => {
                    form.setValues((prev) => ({
                      ...prev,
                      employee1: e ? Number(e) : null,
                      payroll1:
                        e && form.getValues().vehicleCode?.toString() !== "O_TO"
                          ? true
                          : false,
                      driverId:
                        e && typeDelivery !== "DONG_GOI" ? Number(e) : null,
                      driverName:
                        typeDelivery !== "DONG_GOI"
                          ? getValueById(
                              e?.toString() ?? "",
                              dataEmployeedSelect,
                              "label",
                            )
                          : null,
                      driverMobileNumber:
                        typeDelivery !== "DONG_GOI"
                          ? getValueById(
                              e?.toString() ?? "",
                              dataEmployeedSelect,
                              "phoneNumber",
                            )
                          : null,
                    }));
                  }}
                  searchable
                  searchValue={searchEmp1}
                  onSearchChange={setSearchEmp1}
                  clearable
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                  withAsterisk
                />
              </Grid.Col>
              <Grid.Col
                span={{
                  base: 12,
                  md: 6,
                  lg: typeDelivery === "DONG_GOI" ? 2 : 4.5,
                }}
              >
                <Checkbox
                  mt={30}
                  label="Tính lương"
                  checked={form.getValues().payroll1}
                  disabled={
                    form.getValues().vehicleCode?.toString() === "O_TO" ||
                    form.getValues().employee1 === null
                  }
                  {...form.getInputProps("payroll1")}
                  onClick={(e) =>
                    form.setValues((prev) => ({ ...prev, payroll1: !e }))
                  }
                />
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col
                span={{
                  base: 12,
                  md: 6,
                  lg: typeDelivery === "DONG_GOI" ? 10 : 7.5,
                }}
              >
                <Select
                  label="Nhân viên hỗ trợ"
                  placeholder="Nhập tên nhân viên hỗ trợ"
                  data={dataEmployee2Select
                    ?.filter(
                      (item: any) =>
                        item.value !== form.getValues().employee1?.toString(),
                    )
                    ?.map((item: any) => ({
                      value: item.value,
                      label: item.label,
                    }))}
                  value={
                    form.getValues().employee2
                      ? form.getValues().employee2?.toString()
                      : null
                  }
                  searchable
                  searchValue={searchEmp2}
                  onSearchChange={setSearchEmp2}
                  clearable
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                  disabled={!form.getValues().employee1}
                  {...form.getInputProps("employee2")}
                  onChange={(e) => {
                    form.setValues((prev) => ({
                      ...prev,
                      employee2: e ? Number(e) : null,
                      payroll2:
                        e && form.getValues().vehicleCode?.toString() !== "O_TO"
                          ? true
                          : false,
                    }));
                  }}
                />
              </Grid.Col>
              <Grid.Col
                span={{
                  base: 12,
                  md: 6,
                  lg: typeDelivery === "DONG_GOI" ? 2 : 4.5,
                }}
              >
                <Checkbox
                  mt={30}
                  label="Tính lương"
                  checked={form.getValues().payroll2}
                  disabled={
                    form.getValues().vehicleCode?.toString() === "O_TO" ||
                    form.getValues().employee2 === null
                  }
                  {...form.getInputProps("payroll2")}
                  onClick={(e) =>
                    form.setValues((prev) => ({ ...prev, payroll2: !e }))
                  }
                />
              </Grid.Col>
            </Grid>
            {typeDelivery !== "DONG_GOI" && (
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 7.5 }}>
                  <Select
                    label="Lái xe"
                    placeholder="Nhập tên nhân viên lái xe"
                    value={
                      form.getValues().driverId
                        ? form.getValues().driverId?.toString()
                        : null
                    }
                    data={dataEmployeedSelect
                      ?.filter(
                        (item) =>
                          String(item.value) ===
                            String(form.getValues().employee1) ||
                          String(item.value) ===
                            String(form.getValues().employee2),
                      )
                      ?.map((item: any) => ({
                        value: item.value,
                        label: item.label,
                      }))}
                    searchable
                    nothingFoundMessage={
                      (form.getValues().employee1 &&
                        String(form.getValues().employee1).length > 0) ||
                      (form.getValues().employee2 &&
                        String(form.getValues().employee2).length > 0)
                        ? "Không tìm thấy dữ liệu !"
                        : "Vui lòng chọn nhân viên giao hàng hoặc hỗ trợ !"
                    }
                    {...form.getInputProps("driverId")}
                    onChange={(e) => {
                      form.setValues((prev) => ({
                        ...prev,
                        driverId: e ? Number(e) : null,
                        driverName: getValueById(
                          e?.toString() ?? "",
                          dataEmployeedSelect,
                          "label",
                        ),
                        driverMobileNumber: getValueById(
                          e?.toString() ?? "",
                          dataEmployeedSelect,
                          "phoneNumber",
                        ),
                      }));
                    }}
                    withAsterisk
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4.5 }}>
                  <TextInput
                    key={form.key("driverMobileNumber")}
                    label="Số điện thoại người lái"
                    placeholder="Nhập số điện thoại người lái"
                    {...form.getInputProps("driverMobileNumber")}
                  />
                </Grid.Col>
              </Grid>
            )}
          </Fieldset>
        </Grid.Col>
      </Grid>
      {typeDelivery !== "DONG_GOI" && (
        <>
          <ScrollArea
            h={customHeightTable()}
            onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
          >
            <Table
              striped
              highlightOnHover
              withTableBorder
              withColumnBorders
              mt={10}
            >
              <Table.Thead
                className={cx(classes.header, {
                  [classes.scrolled]: scrolled,
                })}
              >
                <Table.Tr>
                  {typeDelivery === "GHEP_DON" ? (
                    <>
                      <Table.Th w={110}>Đơn tính lương</Table.Th>
                      <Table.Th w={110}>Mã đơn</Table.Th>
                      <Table.Th w={125}>Trạng thái đơn</Table.Th>
                    </>
                  ) : (
                    <></>
                  )}
                  <Table.Th>
                    {dataDeliverySelect.length > 1
                      ? "Danh sách điểm đi"
                      : "Điểm đi"}
                  </Table.Th>
                  <Table.Th>
                    {dataDeliverySelect.length > 1
                      ? "Danh sách điểm đến"
                      : "Điểm đến"}
                  </Table.Th>
                  <Table.Th>Quãng đường</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {dataAddress &&
                  dataAddress.length > 0 &&
                  dataAddress.map((i) => (
                    <Table.Tr key={i.id}>
                      {typeDelivery === "GHEP_DON" ? (
                        <>
                          <Table.Td>
                            <Checkbox
                              checked={
                                Number(i.id) ===
                                Number(form.getValues()?.deliveryIdForCombine)
                              }
                              disabled={
                                i?.statusId?.toString() === 9 ||
                                form.getValues()?.isDeliveryOnSite
                              }
                              onChange={() => {
                                form.setValues((prev) => ({
                                  ...prev,
                                  deliveryIdForCombine: Number(i.id),
                                  distance: Number(i.distanceMeters),
                                  distanceTotal: Number(i.distanceMeters),
                                  estimatedTime: Number(i.durationSeconds),
                                  deliveries: form
                                    .getValues()
                                    ?.deliveries?.map((i2) =>
                                      String(i2.deliveryId) === String(i.id)
                                        ? { ...i2, isPayroll: true }
                                        : { ...i2, isPayroll: false },
                                    ),
                                }));
                              }}
                            />
                          </Table.Td>
                          <Table.Td>{i?.sourceCode}</Table.Td>
                          <Table.Td>
                            <Badge
                              color={i?.statusId === 9 ? "yellow" : "blue"}
                            >
                              {i?.deliveryStatusName}
                            </Badge>
                          </Table.Td>
                        </>
                      ) : (
                        <></>
                      )}
                      <Table.Td>{i?.fromAddress}</Table.Td>
                      <Table.Td>
                        {i?.toAddress?.replace(/^(undefined|null) - /, "")}
                      </Table.Td>
                      <Table.Td>{i?.distanceKm} Km</Table.Td>
                    </Table.Tr>
                  ))}
              </Table.Tbody>
            </Table>
          </ScrollArea>

          <Flex
            justify={typeDelivery === "NOI_CHUYEN" ? "space-between" : "end"}
            align={"center"}
            gap={"md"}
          >
            {typeDelivery === "NOI_CHUYEN" ? (
              <Select
                label="Bộ phận giao hàng tiếp theo"
                placeholder="Bộ phận giao hàng tiếp theo"
                value={form.getValues()?.deliveryDepartment}
                data={BPGV}
                size="xs"
                w={300}
                {...form.getInputProps("deliveryDepartment")}
                onChange={(e) =>
                  form.setValues((prev) => ({
                    ...prev,
                    deliveryDepartment: e
                      ? e
                      : dataDeliverySelect[0]?.attribute15,
                  }))
                }
              />
            ) : (
              <></>
            )}
            <Flex gap={"md"} align={"center"}>
              {typeDelivery !== "GHEP_DON" && typeDelivery !== "DONG_GOI" && (
                <>
                  <Checkbox
                    label={"Giao hàng tại chỗ"}
                    checked={form.getValues()?.isDeliveryOnSite}
                    mt={20}
                    onClick={() =>
                      form.setValues((prev) => ({
                        ...prev,
                        isDeliveryOnSite: !form.getValues()?.isDeliveryOnSite,
                        deliveryIdForCombine: null,
                        distance:
                          form.getValues()?.isDeliveryOnSite &&
                          typeDelivery !== "GHEP_DON"
                            ? dataAddress.reduce((sum, i) => {
                                return sum + i.distanceMeters;
                              }, 0)
                            : 0,
                        distanceTotal:
                          form.getValues()?.isDeliveryOnSite &&
                          typeDelivery !== "GHEP_DON"
                            ? dataAddress.reduce((sum, i) => {
                                return sum + i.distanceMeters;
                              }, 0)
                            : 0,
                        estimatedTime:
                          form.getValues()?.isDeliveryOnSite &&
                          typeDelivery !== "GHEP_DON"
                            ? dataAddress.reduce((sum, i) => {
                                return sum + i.durationSeconds;
                              }, 0)
                            : 0,
                        deliveries: dataAddress?.map((i) => ({
                          deliveryId: Number(i.id),
                          durationEstimated: form.getValues()?.isDeliveryOnSite
                            ? i.durationSeconds
                            : 0,
                          distanceEstimated: form.getValues()?.isDeliveryOnSite
                            ? i.distanceMeters
                            : 0,
                          isPayroll: false,
                        })),
                      }))
                    }
                    style={{ cursor: "pointer" }}
                  />
                  <Divider size="sm" orientation="vertical" />
                </>
              )}
              <TextInput
                label="Tổng khoảng cách"
                placeholder="Bấm nút tính khoảng cách để hiển thị"
                value={`${(
                  Number(form.getValues()?.distanceTotal) / 1000
                ).toFixed(2)} Km`}
                variant="filled"
                readOnly
                size="xs"
              />
              <TextInput
                label="Thời gian giao ước tính"
                placeholder="Bấm nút tính khoảng cách để hiển thị"
                value={`${Math.floor(
                  Number(form.getValues()?.estimatedTime) / 3600,
                )} giờ - ${Math.floor(
                  (Number(form.getValues()?.estimatedTime) % 3600) / 60,
                )} phút`}
                variant="filled"
                readOnly
                size="xs"
              />
            </Flex>
          </Flex>
        </>
      )}
      <Group
        justify="end"
        mt="md"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          type="button"
          color="gray"
          loading={visible}
          onClick={() => {
            modals.closeAll();
          }}
          leftSection={!visible ? <IconWindow size={18} /> : undefined}
        >
          Đóng
        </Button>
        <Button
          type="submit"
          color={sky_blue.base}
          loading={visible}
          leftSection={!visible ? <IconCheck size={18} /> : undefined}
          disabled={
            typeDelivery !== "DONG_GOI" &&
            (form.getValues().distanceTotal === null ||
              form.getValues().distanceTotal === undefined ||
              isNaN(Number(form.getValues().distanceTotal)) ||
              (form.getValues().distanceTotal === 0 &&
                !form.getValues()?.isDeliveryOnSite) ||
              (typeDelivery === "GHEP_DON" &&
                form.getValues().deliveryIdForCombine === null) ||
              (typeDelivery === "GHEP_DON" &&
                form.getValues().deliveryIdForCombine === undefined))
          }
        >
          Lưu
        </Button>
        <></>
      </Group>
    </Box>
  );
};

export default DeliveryAssignmentAddressNew;
